import React, { useEffect } from 'react'

export default function IndsatserModal({ indsats, onClose }) {
  useEffect(() => {
    if (!indsats) return
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKeyDown)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = 'unset'
    }
  }, [indsats, onClose])

  if (!indsats) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="indsats-modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-neutral-900/60 backdrop-blur-xs"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-lg bg-white rounded-3xl p-6 sm:p-8 shadow-2xl border border-neutral-100 space-y-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3.5">
            <div className="w-11 h-11 rounded-2xl bg-amber-50 text-[#f39223] flex items-center justify-center shrink-0 text-lg mt-0.5">
              <i className={`fa-solid ${indsats.icon}`} aria-hidden="true" />
            </div>
            <div>
              <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
                Indsatsområde
              </span>
              <h3
                id="indsats-modal-title"
                className="text-lg sm:text-xl font-extrabold text-[#0c304d] leading-snug mt-0.5"
              >
                {indsats.text}
              </h3>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Luk vindue"
            className="w-9 h-9 rounded-full bg-neutral-100 hover:bg-neutral-200 text-neutral-600 flex items-center justify-center shrink-0 transition-colors cursor-pointer"
          >
            <i className="fa-solid fa-xmark text-sm" aria-hidden="true" />
          </button>
        </div>

        <div className="p-5 rounded-2xl bg-amber-50/70 border border-amber-200/80 space-y-2.5">
          <div className="flex items-center gap-2 text-xs font-bold text-[#0c304d]">
            <i className="fa-solid fa-clock text-[#f39223]" aria-hidden="true" />
            <span>Projektstatus</span>
          </div>
          <p className="text-neutral-800 text-base leading-relaxed font-medium">
            Foreningen har søgt om projektmidler og venter lige nu på tilsagn til midler fra forskellige fonde og puljer
          </p>
        </div>

        <div className="flex justify-end pt-1">
          <button
            type="button"
            onClick={onClose}
            className="bg-[#0c304d] hover:bg-[#16466e] text-white font-semibold text-sm px-6 py-2.5 rounded-full transition-colors cursor-pointer shadow-xs"
          >
            Luk
          </button>
        </div>
      </div>
    </div>
  )
}
